import { Component, Input } from '@angular/core';

@Component({
  selector: 'order-summary-questionnaire',
  templateUrl: './order-summary-questionnaire.component.html',
})
export class OrderSummaryQuestionnaireComponent {
  @Input() questionnaireUrl: string;
  @Input() isVirginBrand: boolean;

  constructor() {
  }
}
